<script>
  export default{
    name: 'relogio',
    data () {
      return {
        now: new Date()
      }
    },
    computed: {
      relogio () {
        let hours = String(this.now.getHours())
        let minutes = String(this.now.getMinutes())
        let pad = '00'
        return pad.substring(0, pad.length - hours.length) + hours + ':' + pad.substring(0, pad.length - minutes.length) + minutes
      }
    },
    created () {
      setInterval(() => { this.now = new Date() }, 1000 * 60)
    },
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
  <span>{{ relogio }}</span>
</template>



// WEBPACK FOOTER //
// Relogio.vue?7a0e5cbc